import { InternalReportKey, RELATIONSHIP_KEY, RELATIONSHIP_NAME } from 'src/app/shared/model/score-card.model';
import { USERTYPE } from './../../../../../core/enums/routing-item.enum';

// tslint:disable-next-line:class-name
export const  PERFORMANCES_MODEL = {
  perfQyTQS: {
    name: InternalReportKey.perfQyTQS,
    title: 'Total Quality Score',
    type: USERTYPE.SUPPLIER_USER
  },
  perfQyEDR: {
    name: InternalReportKey.perfQyEDR,
    title: 'Escaping Defects (NCR, PAC, COPQ)',
  },
  perfQyAPQP4Wind: {
    name: InternalReportKey.perfQyAPQP4Wind,
    title: 'APQP4Wind',
  },
  perfQyMD: {
    name: InternalReportKey.perfQyMD,
    title: 'Major Disruption',
  },
  perfYoYCoSP: {
    name: InternalReportKey.perfYoYCoSP,
    title: 'Cost YoY',
    subTitle: '',
    unit: '%',
    type: USERTYPE.SUPPLIER_USER,
  },
  perfYoYCoPCO: {
    name: InternalReportKey.perfYoYCoPCO,
    title: 'YoY Cost Out %',
    subTitle: '(PCO)',
    unit: '%',
  },
  perfOTDPD: {
    name: InternalReportKey.perfOTDPD,
    title: 'OTD% Promised Date',
    subTitle: '',
    unit: '%',
    type: USERTYPE.SUPPLIER_USER,
  },
  perfOTDPN: {
    name: InternalReportKey.perfOTDPN,
    title: 'OTD%',
    subTitle: '(Plan Needs)',
    unit: '%',
  },
  perfDyDLPD: {
    name: InternalReportKey.perfDyDLPD,
    title: 'Days Late',
    subTitle: '',
    type: USERTYPE.SUPPLIER_USER,
  },
  perfDyDLPN: {
    name: InternalReportKey.perfDyDLPN,
    title: 'Days Late',
    subTitle: '(Plan Needs)',
  },
  perfCnRTPD: {
    name: InternalReportKey.perfCnRTPD,
    title: 'Payment Days vs Target',
    unit: ' days',
    type: USERTYPE.SUPPLIER_USER,
  },
  perfCnRTLT: {
    name: InternalReportKey.perfCnRTLT,
    title: 'Lead Time vs Target',
    type: USERTYPE.SUPPLIER_USER,
  },
  perfSustain: {
    name: InternalReportKey.perfSustain,
    title: 'Sustainability Overall Score',
    type: USERTYPE.SUPPLIER_USER,
    subTitle: ''
  },
  envW: {
    name: InternalReportKey.envW,
    title: 'Enviroment',
    type: USERTYPE.SUPPLIER_USER,
    subTitle: ''
  },
  labW: {
    name: InternalReportKey.labW,
    title: 'Labor & Human Rights',
    type: USERTYPE.SUPPLIER_USER,
    subTitle: ''
  },
  ethW: {
    name: InternalReportKey.ethW,
    title: 'Ethics',
    type: USERTYPE.SUPPLIER_USER,
    subTitle: ''
  },
  supW: {
    name: InternalReportKey.supW,
    title: 'Sustainable Procurement',
    type: USERTYPE.SUPPLIER_USER,
    subTitle: ''
  },
  perfFiHeRa: {
    name: InternalReportKey.perfFiHeRa,
    title: '(FHR) Financial Health Rating',
    type: USERTYPE.SUPPLIER_USER,
  }
};


export const RELATIONSHIP_MODEL = {
  relsCI: {
    name: RELATIONSHIP_KEY.relsCI,
    title: RELATIONSHIP_NAME.relsCI,
    n: 15,
    m: 22.5,
    value: '',
    compare: ['<=', '>='],
    type: USERTYPE.SUPPLIER_USER
  },
  relsTI: {
    name: RELATIONSHIP_KEY.relsTI,
    title: RELATIONSHIP_NAME.relsTI,
    n: 10,
    m: 22.5,
    value: '',
    compare: ['<=', '>='],
    type: USERTYPE.SUPPLIER_USER
  },
  relsR: {
    name: RELATIONSHIP_KEY.relsR,
    title: RELATIONSHIP_NAME.relsR,
    n: 7,
    m: 16,
    value: '',
    compare: ['<=', '>='],
    type: USERTYPE.SUPPLIER_USER
  },
  relsCF: {
    name: RELATIONSHIP_KEY.relsCF,
    title: RELATIONSHIP_NAME.relsCF,
    n: 10,
    m: 16,
    value: '',
    compare: ['<=', '>='],
    type: USERTYPE.SUPPLIER_USER
  },
  relsGFS: {
    name: RELATIONSHIP_KEY.relsGFS,
    title: RELATIONSHIP_NAME.relsGFS,
    n: 4,
    m: 9,
    value: '',
    compare: ['<=', '>='],
    type: USERTYPE.INTERNAL_USER
  },
};

export const SEGMENTATION = [
  {
    name: 'totalRelationShipScore',
    title: 'Total Behaviors Score',
    value: '0',
    maxScore: {
      name: 'relationShipMaxScore',
      value: ''
    }
  },
  {
    name: 'totalPerformanceScore',
    title: 'Total Performance Score',
    value: '0',
    maxScore: {
      name: 'performanceMaxScore',
      value: ''
    }
  },
  {
    name: 'totalScore',
    title: 'Total Score',
    value: '0',
    maxScore: {
      name: 'totalMaxScore',
      value: ''
    }
  },
  {
    name: 'supplierClassification',
    title: 'Supplier Classification',
    value: '0',
  }
];


export const DISPLAY_COLUMN = [
  'parentCompany',
  'supplierName',
  'pyspend',
  'ytdspend',
  'qualityTotalQScore',
  'ytdcostOutPCO',
  'deliveryOTDPercentPromised',
  'paymentDaysVsTarget',
  'leadTimeVsTarget',
  'performanceScore',
  'relationshipScore',
  'totalScore',
  'segmentClass',
];

export const DISPLAY_KPI = [
  'totalQualityScore',
  'otdPromiseDate',
  'yoyCostOutSupplierPrice',
  'daysLatePromisedDate',
  'paymentDaysVsTarget',
  'leadTimeVsTarget',
  'perfSustain',
  'financialHealthRating'
];

export const DISPLAY_SCORING_SEGMENT = [
  'performanceScore',
  'performanceQualityTotalQScore',
  'performanceDeliveryOtdPercentPromised',
  'performanceLeadTimeVsTarget',
  'performanceYTDCostOutOrCostDeflationPCO',
  'performancePaymentDaysVsTarget',
  'performanceFinancialHealthRating',
  'performanceSustain',
  'relationshipScore',
  'complianceAndIntegrity',
  'technologyAndInnovation',
  'responsiveness',
  'scCompetencyAndFootprint',
  'geFlexibilityToSwitch',
  'totalScore',
  'commercialClassGap',
  'segmentClass',
  'commercialClass'
];

export const DISPLAY_KPI_GROUP = [
  'perfSustain',
  'envW',
  'labW',
  'ethW',
  'supW',
  'qualityTotalQScore',
  'apqp4Wind',
  'escapingDefect',
  'majorDisruption',
  'deliveryOTDPercentPromised',
  'daysLatePromisedDate',
  'deliveryOtdPercentNeeds',
  'daysLatePlantNeeds',
  'promisedDateVsNeedDate',
  'missingPromisedDatePercent',
  'leadTimeVsTarget',
  'ytdcostOutPCO',
  'ytdCostOutSupplierDeflation',
  'ytdSupplierDeflation',
  'paymentDaysVsTarget',
  'perfFiHeRa'
];

export const DISPLAY_SUSTAIN_KPI = [
  'perfSustain',
  'envW',
  'labW',
  'ethW',
  'supW'
];

export const DISPLAY_QUALITY_KPI = [
  'totalQualityScore',
  'apqp4Wind',
  'escapingDefect',
  'majorDisruption'
];

export const DISPLAY_DELIVERY_KPI = [
  'otdPromiseDate',
  'daysLatePromisedDate',
  'leadTimeVsTarget'
];

export const DISPLAY_COST_KPI = [
  'yoyCostOutSupplierPrice',
  'paymentDaysVsTarget'
];


export const INTERNAL_REPORT_TABLE: TableSettings[] = [
  {
    displayedColumns: 'parentCompany',
    header: 'Parent Supplier Name',
    subHeader: '',
    field: 'parentCompany',
    show: true,
    sortHeader: true,
    width: '150px',
    minWidth: '150px',
  },
  {
    displayedColumns: 'supplierName',
    header: 'Supplier Name & GSL',
    subHeader: '',
    field: 'supplierName',
    show: true,
    sortHeader: false,
    width: '150px',
    minWidth: '150px',
  },
  {
    displayedColumns: 'commodity',
    header: 'Commodity',
    subHeader: '',
    field: 'commodity',
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'pyspend',
    header: 'PY Spend',
    subHeader: '(USD)',
    field: 'pyspend',
    show: true,
    sortHeader: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'ytdspend',
    header: 'Period Spend',
    subHeader: '(USD)',
    field: 'ytdspend',
    show: true,
    sortHeader: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'perfSustain',
    header: 'Sustainability Overall Score',
    subHeader: '',
    field: 'perfSustain',
    hasShowDetails: true,
    showDetail: false,
    show: true,
    sortHeader: true,
    minWidth: '150px',
    numOfChilds: 4,
  },
  {
    displayedColumns: 'envW',
    parentName: 'perfSustain',
    header: 'Environment',
    subHeader: '',
    field: 'envW',
    show: false,
    showDetail: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'labW',
    parentName: 'perfSustain',
    header: 'Labor & Human Rights',
    subHeader: '',
    field: 'labW',
    show: false,
    showDetail: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'ethW',
    parentName: 'perfSustain',
    header: 'Ethics',
    subHeader: '',
    field: 'ethW',
    show: false,
    showDetail: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'supW',
    parentName: 'perfSustain',
    header: 'Sustainable Procurement',
    subHeader: '',
    field: 'supW',
    show: false,
    showDetail: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'qualityTotalQScore',
    header: 'Quality',
    subHeader: '(Total Qscore)',
    field: 'qualityTotalQScore',
    hasShowDetails: true,
    showDetail: false,
    show: true,
    sortHeader: true,
    hasTrendingChart: true,
    minWidth: '150px',
    numOfChilds: 3,
  },
  {
    displayedColumns: 'apqp4Wind',
    parentName: 'qualityTotalQScore',
    header: 'APQP4Wind',
    subHeader: '',
    field: 'apqp4Wind',
    show: false,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'escapingDefect',
    parentName: 'qualityTotalQScore',
    header: 'Escaping Defects (NCR, PAC, COPQ)',
    subHeader: '',
    field: 'escapingDefect',
    show: false,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'majorDisruption',
    parentName: 'qualityTotalQScore',
    header: 'Major Disruption',
    subHeader: '',
    field: 'majorDisruption',
    show: false,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'deliveryOTDPercentPromised',
    header: 'Delivery',
    subHeader: '(OTD% Promised)',
    field: 'deliveryOTDPercentPromised',
    hasShowDetails: true,
    showDetail: false,
    show: true,
    sortHeader: false,
    unit: '%',
    hasTrendingChart: true,
    minWidth: '150px',
    numOfChilds: 5,
  },
  {
    displayedColumns: 'daysLatePromisedDate',
    parentName: 'deliveryOTDPercentPromised',
    header: 'Days Late',
    subHeader: '(Promised date)',
    field: 'daysLatePromisedDate',
    show: false,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'deliveryOtdPercentNeeds',
    parentName: 'deliveryOTDPercentPromised',
    header: 'Delivery',
    subHeader: '(OTD% Needs)',
    field: 'deliveryOtdPercentNeeds',
    show: false,
    sortHeader: false,
    unit: '%',
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'daysLatePlantNeeds',
    parentName: 'deliveryOTDPercentPromised',
    header: 'Days Late',
    subHeader: '(Plant Needs)',
    field: 'daysLatePlantNeeds',
    show: false,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'promisedDateVsNeedDate',
    parentName: 'deliveryOTDPercentPromised',
    header: 'Promised date vs. Need date',
    subHeader: '',
    field: 'promisedDateVsNeedDate',
    show: false,
    sortHeader: false,
    unit: '%',
    minWidth: '150px',
  },
  {
    displayedColumns: 'missingPromisedDatePercent',
    parentName: 'deliveryOTDPercentPromised',
    header: 'Missing Promised Date %',
    subHeader: '',
    field: 'missingPromisedDatePercent',
    show: false,
    sortHeader: false,
    unit: '%',
    minWidth: '150px',
  },
  {
    displayedColumns: 'leadTimeVsTarget',
    header: 'Lead Time vs Target',
    subHeader: '',
    field: 'leadTimeVsTarget',
    show: true,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'ytdcostOutPCO',
    header: 'PCO Cost-out YTD',
    subHeader: '',
    field: 'ytdcostOutPCO',
    hasShowDetails: true,
    showDetail: false,
    show: true,
    sortHeader: false,
    unit: '%',
    hasTrendingChart: true,
    minWidth: '150px',
    hasInforCostout: true,
    numOfChilds: 2,
  },
  {
    displayedColumns: 'ytdCostOutSupplierDeflation',
    parentName: 'ytdcostOutPCO',
    header: 'Supplier Cost Out-',
    subHeader: 'Period vs LY',
    field: 'ytdCostOutSupplierDeflation',
    show: false,
    sortHeader: false,
    unit: '%',
    hasTrendingChart: true,
    minWidth: '150px',
    hasInforCostout: true,
  },
  {
    displayedColumns: 'ytdSupplierDeflation',
    parentName: 'ytdcostOutPCO',
    header: 'Supplier Cost-out',
    subHeader: 'YTD vs LY',
    field: 'ytdSupplierDeflation',
    show: false,
    sortHeader: false,
    unit: '%',
    hasTrendingChart: true,
    minWidth: '150px',
    hasInforCostout: true,
  },
  {
    displayedColumns: 'paymentDaysVsTarget',
    header: 'Payment Days vs Target',
    subHeader: '',
    field: 'paymentDaysVsTarget',
    show: true,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'perfFiHeRa',
    header: '(FHR)',
    subHeader: 'Financial Health Rating',
    content: '',
    showDetail: true,
    field: 'perfFiHeRa',
    show: true,
    sortHeader: false,
    hasTrendingChart: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'performanceScore',
    header: 'Performance Score',
    subHeader: '',
    content: 'Max 115',
    field: 'performanceScore',
    hasShowDetails: true,
    showDetail: false,
    show: true,
    sortHeader: true,
    minWidth: '150px',
    numOfChilds: 7,
  },
  {
    displayedColumns: 'performanceQualityTotalQScore',
    parentName: 'performanceScore',
    header: 'Quality',
    subHeader: '(Total Qscore)',
    // content: 'Max 25',
    field: 'performanceQualityTotalQScore',
    show: false,
    showDetail: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'performanceDeliveryOtdPercentPromised',
    parentName: 'performanceScore',
    header: 'Delivery',
    subHeader: '(OTD% Promised)',
    // content: 'Max 20',
    showDetail: true,
    field: 'performanceDeliveryOtdPercentPromised',
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'performanceLeadTimeVsTarget',
    parentName: 'performanceScore',
    header: 'Lead Time vs Target',
    subHeader: '',
    // content: 'Max 20',
    showDetail: true,
    field: 'performanceLeadTimeVsTarget',
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'performanceYTDCostOutOrCostDeflationPCO',
    parentName: 'performanceScore',
    header: 'PCO Cost-out YTD',
    subHeader: '',
    // content: 'Max 20',
    showDetail: true,
    field: 'performanceYTDCostOutOrCostDeflationPCO',
    show: false,
    sortHeader: false,
    minWidth: '150px'
  },
  {
    displayedColumns: 'performancePaymentDaysVsTarget',
    parentName: 'performanceScore',
    header: 'Payment Days vs Target',
    subHeader: '',
    // content: 'Max 10',
    showDetail: true,
    field: 'performancePaymentDaysVsTarget',
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'performanceFinancialHealthRating',
    parentName: 'performanceScore',
    header: 'Financial Health Rating',
    subHeader: '',
    // content: 'Max 10',
    showDetail: true,
    field: 'performanceFinancialHealthRating',
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'performanceSustain',
    parentName: 'performanceScore',
    header: 'Sustainability Overall Score',
    subHeader: '',
    // content: 'Max 10',
    showDetail: true,
    field: 'performanceSustain',
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'relationshipScore',
    header: 'Behaviors Score',
    subHeader: '',
    field: 'relationshipScore',
    content: 'Max 85',
    hasShowDetails: true,
    showDetail: false,
    show: true,
    sortHeader: true,
    minWidth: '150px',
    numOfChilds: 5,
  },
  {
    displayedColumns: 'complianceAndIntegrity',
    parentName: 'relationshipScore',
    header: 'Law & Regulation',
    subHeader: '',
    field: 'complianceAndIntegrity',
    // content: 'Max 85',
    showDetail: true,
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'technologyAndInnovation',
    parentName: 'relationshipScore',
    header: 'Drive Innovation',
    subHeader: '',
    field: 'technologyAndInnovation',
    // content: 'Max 85',
    showDetail: true,
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'responsiveness',
    parentName: 'relationshipScore',
    header: 'Customer Focus',
    subHeader: '',
    field: 'responsiveness',
    // content: 'Max 85',
    showDetail: true,
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'scCompetencyAndFootprint',
    parentName: 'relationshipScore',
    header: 'Lean Mindset',
    subHeader: '',
    field: 'scCompetencyAndFootprint',
    // content: 'Max 85',
    showDetail: true,
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'geFlexibilityToSwitch',
    parentName: 'relationshipScore',
    header: `GE's Flexibility to switch`,
    subHeader: '',
    field: 'geFlexibilityToSwitch',
    // content: 'Max 85',
    showDetail: true,
    show: false,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'totalScore',
    header: 'Total Score',
    subHeader: '',
    field: 'totalScore',
    show: true,
    sortHeader: true,
    minWidth: '150px',
  },
  {
    displayedColumns: 'commercialClassGap',
    header: 'Gap to Commercial Class',
    subHeader: '',
    field: 'commercialClassGap',
    show: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'segmentClass',
    header: 'Scoring Class',
    subHeader: '',
    field: 'segmentClass',
    show: true,
    sortHeader: false,
    minWidth: '150px',
  },
  {
    displayedColumns: 'commercialClass',
    header: 'Commercial Class',
    subHeader: '',
    field: 'commercialClass',
    show: true,
    sortHeader: false,
    minWidth: '150px',
  }
];

export class Relationship {
  name: string;
  title: string;
  min: number;
  max: number;
  value: number;
}

export class TableSettings {
  displayedColumns: string;
  parentName?: string;
  header: string;
  subHeader: string;
  field: string;
  showDetail?: boolean;
  hasShowDetails?: boolean;
  show?: boolean;
  content?: string;
  className?: any | Function;
  sortHeader: boolean;
  width?: string;
  unit?: string;
  hasTrendingChart?: boolean;
  minWidth?: string;
  hasInforCostout?: boolean;
  numOfChilds?: number;

  constructor() {
    this.show = true;
    this.showDetail = false;
  }
}

export const enum VIEW_TYPE {
  TABLEAU = 1,
  TABLE = 2,
}

export class ButtonFunction {
  name?: string;
  method?: () => void;
}